import React from 'react';
import Icon from '../../../../components/AppIcon';
import Button from '../../../../components/ui/Button';

const PermissionModal = ({ type, onAllow, onDeny, isVisible }) => {
  if (!isVisible) return null;

  const permissionConfig = {
    camera: {
      icon: 'Camera',
      title: 'Camera Access Required',
      description: 'Selfie attendance needs access to your camera to capture your selfie for attendance verification. Your photos are securely stored and only used for attendance purposes.',
      features: [
        'Capture selfie for attendance verification',
        'Prevent time fraud and buddy punching',
        'Secure storage with private access',
        'GDPR compliant data handling'
      ]
    },
    location: {
      icon: 'MapPin',
      title: 'Location Access Required',
      description: 'Selfie attendance needs access to your location to verify your attendance from the correct workplace. Your location data is encrypted and only used for attendance tracking.',
      features: [
        'Verify attendance from correct location',
        'Track work location compliance',
        'Prevent location spoofing',
        'Encrypted location storage'
      ]
    }
  };

  const config = permissionConfig?.[type];

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 md:p-6 bg-background/80 backdrop-blur-sm">
      <div className="w-full max-w-md bg-card rounded-2xl shadow-elevation-5 overflow-hidden">
        <div className="p-6 md:p-8 lg:p-10">
          <div className="flex flex-col items-center text-center mb-6 md:mb-8">
            <div className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-full bg-primary/10 flex items-center justify-center mb-4 md:mb-6">
              <Icon name={config?.icon} size={32} className="md:w-10 md:h-10 lg:w-12 lg:h-12 text-primary" />
            </div>
            <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground mb-2 md:mb-3">{config?.title}</h2>
            <p className="text-sm md:text-base lg:text-lg text-muted-foreground">{config?.description}</p>
          </div>

          <div className="space-y-3 md:space-y-4 mb-6 md:mb-8">
            {config?.features?.map((feature, index) => (
              <div key={index} className="flex items-start gap-3 md:gap-4">
                <div className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-success/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Icon name="Check" size={14} className="md:w-4 md:h-4 text-success" />
                </div>
                <p className="text-sm md:text-base text-foreground flex-1">{feature}</p>
              </div>
            ))}
          </div>

          <div className="flex flex-col gap-2 md:gap-3">
            <Button
              variant="default"
              onClick={onAllow}
              iconName="Check"
              iconPosition="left"
              fullWidth
            >
              Allow Access
            </Button>
            <Button
              variant="outline"
              onClick={onDeny}
              fullWidth
            >
              Deny
            </Button>
          </div>

          <div className="mt-4 md:mt-6 p-3 md:p-4 bg-muted rounded-lg">
            <div className="flex items-start gap-2 md:gap-3">
              <Icon name="Shield" size={16} className="md:w-5 md:h-5 text-muted-foreground flex-shrink-0 mt-0.5" />
              <p className="text-xs md:text-sm text-muted-foreground">Your privacy is protected. All data is encrypted and stored securely according to GDPR standards.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PermissionModal;


